<template>
  <div class="container">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item label="名称">
        <a-input placeholder="请输入名称" v-decorator="['name']" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" style="margin-right: 8px">
          查询
        </a-button>
        <a-button @click="resetForm">
          重置
        </a-button>
      </a-form-item>
    </a-form>
    <a-button
      type="primary"
      icon="plus"
      @click="handleAdd"
      style="margin: 20px 0;"
      >新建</a-button
    >
    <div>
      <a-table
        :columns="columns"
        :data-source="list"
        rowKey="id"
        :pagination="{
          current: page,
          total: total,
          pageSize: size,
          onChange: onPageChange
        }"
      >
        <template slot="idx" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确认要删除么？"
            ok-text="是"
            cancel-text="否"
            @confirm="handleDelete(record.id)"
            @cancel="
              () => {
                $message.error('取消删除');
              }
            "
          >
            <a style="color: #1890ff">删除 </a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <add-or-edit-route
      :action="action"
      :visible.sync="visible"
      :record="record"
      @onOk="
        v => {
          visible = v;
          getPatrolRouteList();
        }
      "
    ></add-or-edit-route>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getPatrolRouteList, deletePatrolRoute } from "@/api/api";
import AddOrEditRoute from "./components/AddOrEditRoute";
import { patrol_route_columns } from "@/options/columns";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns: patrol_route_columns,
      list: [],
      visible: false,
      page: 1,
      size: 10,
      total: 0,
      action: "",
      record: {}
    };
  },
  components: {
    AddOrEditRoute
  },
  computed: {
    ...mapState(["authUserInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    this.getPatrolRouteList();
  },
  methods: {
    async getPatrolRouteList() {
      const fieldsValue = this.form.getFieldsValue();
      let name = fieldsValue.name ?? "";
      let res = await getPatrolRouteList({
        group_id: this.defaultInfo.defaultGroupId,
        name: name,
        page: this.page,
        size: this.size
      });
      this.list = res.data.items;
      this.total = res.data.total;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.getPatrolRouteList();
        }
      });
    },
    onPageChange(v) {
      this.page = v;
      this.getPatrolRouteList();
    },
    resetForm() {
      this.form.resetFields();
    },
    handleAdd() {
      this.action = "add";
      this.visible = true;
    },
    handleEdit(record) {
      this.action = "edit";
      this.record = record;
      this.visible = true;
    },
    async handleDelete(id) {
      try {
        let res = await deletePatrolRoute(id);
        await this.getPatrolRouteList();
        this.$message.success(res.data.msg);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}
</style>
